'use strict';

import dispatcher from '../dispatcher';


let titleInner;
let inner;


function _handleChange(e) {
  if (e.hasOwnProperty('status')) {
    titleInner.innerHTML = e.title;
    inner.innerHTML = e.text;

    dispatcher.dispatch({
      type: 'popup-toggle',
      _module: 'response.view',
      id: 'popup-response'
    });

    if (e.status === 'error') {
      setTimeout(function () {
        dispatcher.dispatch({
          type: 'popup-close-all',
          _module: 'response.view'
        });
      }, 4000);
    }

  } else {
    titleInner.innerHTML = '';
    inner.innerHTML = '';

    dispatcher.dispatch({
      type: 'popup-close-all',
      _module: 'response.view'
    });
  }
}


function init() {
  titleInner = document.querySelector('.response-title');
  inner = document.querySelector('.response-text');

  if (!titleInner || !inner) return;

  dispatcher.subscribe(function (e) {
    if (e.type === 'show-response') {
      _handleChange(e);
    }
  });
}

export default {
  init: init
}